/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Editedat1Inputs */

const de__field_editedat1 = /** @type {(inputs: _Field_Editedat1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bearbeitet am`)
};

/**

* @param {_Field_Editedat1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_editedat1 = /** @type {((inputs?: _Field_Editedat1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Editedat1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_editedat1(inputs)
});
export { _field_editedat1 as "_field_editedAt" }